<template>
    <div>
    <Header></Header>
    <Login></Login>
    <div class="productIntro-list">
        <div class="productIntro-list-item" v-for="(item,index) in productIntroList" :key="index">
            <div class="product-item-info" :style="{background:'url('+item.productIntroItemBg+') 0% 0% / 100% 100%'}">
                <div class="productIntro-item-info-wrapper">
                  <div>
                    <div class="productIntro-item-title">{{item.productIntroItemTitle}}</div>
                    <div class="productIntro-item-title-content">“小房书” 门店管理系统虽然萌芽于澜思内部的案例数据库，但其出发点在于我们希望通过二手房成交数据与二手经纪门店管理者之间达成协作，从而<span>对经纪人及楼盘进行分类管理，以便更好地达到数据驱动运营的目的</span>。 目前该产品已经上线3.0门店版，拥有PC及小程序端，相比之前的SAAS产品，该产品可在经纪人的移动作业中进行较好的产品落地。</div>
                  </div>
                  <div class="productIntro-item-img"><img src="../assets/images/productIntro/小房书bg@2x.png" /></div>
                </div>
            </div>
            <div class="product-advantage">
                <div class="product-advantage-title">产品优势</div>
                <div class="product-advantage-enTitle">Product Advantages</div> 
                <div class="product-advantage-list">
                    <div class="product-advantage-list-item" v-for="(v,i) in item.productAdvantageList" :key="i">
                        <div class="product-advantage-list-item-wrapper">
                            <div class="product-advantage-img">
                                <img :src="v.productAdvantageIcon" alt="">
                            </div>
                            <div class="product-advantage-text">{{v.productAdvantageTitle}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-function">
                <div class="product-function-title">产品主要功能</div>
                <div class="product-function-enTitle">The Main Function of The Product</div>
                <div class="product-function-list">
                    <div class="product-function-item" v-for="(vv,ii) in item.productFunctionList" :key="ii">
                        <div class="product-function-item-left">
                            <img :src="vv.productFunctionImgUrl" alt="">
                        </div>
                        <div class="product-function-item-right">
                            <div class="product-function-item-title">{{vv.productFunctionText}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="customer-case">
                <div class="customer-case-title">客户案例</div>
                <div class="customer-case-enTitle">Customer Case</div>
                <div class="customer-case-content" :style="{background:'url('+item.customerCaseBgUrl+') 0% 0% / 100% 100%'}">
                   <div class="customer-case-content-wrapper">
                      <div class="customer-case-content-title">{{item.customerCaseContentTitle}}</div>
                      <div class="customer-case-content-text">{{item.customerCaseContentText}}</div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Login from "@/components/Login.vue";
export default {
  name: "productIntro",
  components: {
    Header,
    Footer,Login
  },
  data() {
    return {
      productIntroList: [
        {
          id: 2,
          productIntroItemBg: require("../assets/images/productIntro/banner-bg@2x.png"),
          productIntroItemTitle: `"HOUSEBOOK小房书"门店管理系统`,
          productIntroItemContent:
            "“小房书” 门店管理系统虽然萌芽于澜思内部的案例数据库，但其出发点在于我们希望通过二手房成交数据与二手经纪门店管理者之间达成协作，从而",
          productAdvantageList: [
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_xiaofangshu2.png"),
              productAdvantageTitle: "PC端+小程序端可移动作业"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_xiaofangshu1.png"),
              productAdvantageTitle: "提升运营管理效率"
            },
            {
              productAdvantageIcon: require("../assets/images/productIntro/icon_xiaofangshu0.png"),
              productAdvantageTitle: "房源清洗"
            }
          ],
          productFunctionList: [
            {
              productFunctionImgUrl: require("../assets/images/productIntro/主要功能-小房书@2x.png"),
              productFunctionText: "宏观市场、门店、楼盘、板块、一键查成交"
            }
          ],
          customerCaseBgUrl: require("../assets/images/productIntro/客户案例-小房书bg@2x.png"),
          customerCaseContentTitle: "接城地产",
          customerCaseContentText:
            "通过“小房书”系统，可支持到房源清洗、业务复盘等门店运营管理中"
        }
      ]
    };
  },
  methods: {},
  created() {}
};
</script>

<style lang="less" scoped>
@import "../assets/css/productIntro.less";
</style>


